import postAPI from './postAPI.js'

export default async function postUploadChunk(data) {
    const response = await postAPI('taskinstances/steps/upload/chunk', data);
    return response;
}
